import { render, staticRenderFns } from "./CarouselPage.vue?vue&type=template&id=6df668f8&"
import script from "./CarouselPage.vue?vue&type=script&lang=js&"
export * from "./CarouselPage.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports